module.exports = __webpack_public_path__ + "static/img/osde-3.5f455ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/osde-3.jpg
// module id = t/eG
// module chunks = 1